module.exports = __webpack_public_path__ + "static/warforged_wizard_WGtE-60e6435bcebffdf36051d1ff09d8f2e9.png";